import React from 'react';
import PropTypes from "prop-types";

const propTypes = {
	id: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired,
	owner: PropTypes.string.isRequired,
	area: PropTypes.string.isRequired,
	address: PropTypes.string,
	address2: PropTypes.string,
	zipcode: PropTypes.number,
	city: PropTypes.string,
	state: PropTypes.string,
	url: PropTypes.string,
	phone: PropTypes.string,
	email: PropTypes.string
}

const DirectoryItem = ({id, name, owner, area, address, address2, zipcode, city, state, url, phone, email}) => {
		return <div className="cdm-directory--detail" key={`dir-entry-${id}`}>
			<h5 className="title is-5">{name}</h5>
			<p>
				<span>Titular</span>
				{owner}
			</p>
			<p>
				<span>Área de incidencia</span>
				{area}
			</p>
			<p>
				<span>Dirección</span>
				{address} <br/>
				{address2} <br/>
				{zipcode} {city}, {state}
			</p>
			<p>
				<span>Página web</span>
				{url}
			</p>
			<p>
				<span>Teléfono</span>
				{phone}
			</p>
			<p>
				<span>E-mail</span>
				{email}
			</p>
		</div>
}

DirectoryItem.propTypes = propTypes;

export default DirectoryItem;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/directory/directory-item.jsx